import axios from "axios";
import { useNavigate } from "react-router-dom";
const getAccessToken = () => localStorage.getItem("access");

const token = getAccessToken();
export const headers = {
  "Content-Type": "application/json",
};
const getAxiosInterceptor = () => {
  const axiosInterceptor = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  });

  axiosInterceptor.interceptors.request.use(
    async (config) => {
      const token = localStorage.getItem("access");

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInterceptor.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      const navigate = useNavigate();
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const refreshToken = localStorage.getItem("refresh");

          const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/token/refresh`,
            {
              refreshToken,
            }
          );

          localStorage.setItem("access", response.data.access);
          localStorage.setItem("refresh", response.data.refresh);

          originalRequest.headers.Authorization = `Bearer ${response.data.access}`;

          return axiosInterceptor(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem("access");
          localStorage.removeItem("refresh");

          navigate("/login");
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    }
  );

  return axiosInterceptor;
};

export default getAxiosInterceptor;
